import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchItemCardModelsIfNeeded } from '@/redux/modules/itemCardModel';
import { fetchRecommendedItemIfNeeded, getSortedRecommendedItemIdsFromState } from '@/redux/modules/recommendedItem';

export default ({ match, store }: DataLoaderParams) => {
    const { dispatch, getState } = store;
    const {
        params: { amazon },
    } = match;

    return dispatch(fetchRecommendedItemIfNeeded(Boolean(amazon))).then(() => {
        const state = getState();
        const itemIds = getSortedRecommendedItemIdsFromState(state, 0);
        return dispatch(fetchItemCardModelsIfNeeded(itemIds, 'RECOMMENDED-ITEMS-PAGE'));
    });
};
